// extracted by mini-css-extract-plugin
export var container = "_b2-0";
export var containerTopRight = "_b2-1";